import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import AddMTPackage from "./addMTPackage";
import AddWSPackage from "./addWSPackage";
import { gql, useLazyQuery } from "@apollo/client";

function AddPackage(props) {
  const GETPRODUCTS = gql`
    query getProducts(
      $paginateInput: PaginateInput!
      $searchInput: ProductSearchInput!
    ) {
      getProducts(paginateInput: $paginateInput, searchInput: $searchInput) {
        id
        name
        category
      }
    }
  `;
  const [workSpaces, setWorkSpace] = useState([]);
  const [meeringRooms, setMeetingRooms] = useState([]);
  const [getProducts, products] = useLazyQuery(GETPRODUCTS, {
    fetchPolicy: "no-cache",
    onCompleted({ getProducts }) {
      const services = getProducts.map((obj) => {
        const { name, id, category } = obj;
        return { label: name, value: id, category };
      });
      setWorkSpace(
        services.filter((service) => service.category === "WORK_SPACE")
      );
      setMeetingRooms(
        services.filter((service) => service.category === "MEETING_ROOM")
      );
    },
  });

  useEffect(() => {
    getProducts({
      variables: {
        paginateInput: {
          page: 1,
          perPage: 50,
        },
        searchInput: {
          category: ["WORK_SPACE", "MEETING_ROOM"],
        },
      },
    });
  }, []);

  const items = [
    {
      label: "فضای کار",
      key: "workSpace",
      children: (
        <AddWSPackage services={workSpaces} loading={products.loading} />
      ),
    },
    {
      label: "اتاق جلسات",
      key: "meetingRoom",
      children: (
        <AddMTPackage services={meeringRooms} loading={products.loading} />
      ),
    },
  ];
  return (
    <div>
      <Tabs items={items} />
    </div>
  );
}

export default AddPackage;
